/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import _ from 'lodash';

const getNestedErrors = errorData => {
  let errorMsg = '';
  if (Array.isArray(errorData) && errorData.length) {
    let errorArray = [];
    errorData.forEach(err => {
      if (err.message) {
        errorArray.push(err.message);
      } else if (typeof err === 'string') {
        errorArray.push(err);
      } else if (
        Array.isArray(err) &&
        err.length > 0 &&
        typeof err[0] === 'string'
      ) {
        errorArray = errorArray.concat(err);
      } else {
        const keys = Object.keys(err);
        if (keys.length) {
          const key = keys[0];
          if (Array.isArray(err[key])) {
            err[key].forEach(innerErr => {
              if (innerErr) {
                if (innerErr.constructor === String) {
                  errorArray.push(innerErr);
                } else {
                  errorArray = errorArray.concat(Object.values(innerErr));
                }
              }
            });
          } else if (typeof err[key] === 'object') {
            errorArray = errorArray.concat(Object.values(err[key]));
          }
        }
      }
    });
    errorMsg = errorArray.join(' ');
  } else if (typeof errorData === 'string') {
    errorMsg = errorData;
  } else if (_.isObject(errorData)) {
    const _error = errorData as any;
    if (_error.message && typeof _error.message === 'string') {
      errorMsg += _error.message;
    } else if (_error.error && typeof _error.error === 'string') {
      errorMsg += _error.error;
    }
  }
  return errorMsg;
};

export const getErrorString = errorObj => {
  let errorDetails = '';
  const validationErrors =
    _.get(errorObj, 'data.errors') || _.get(errorObj, 'data.error', null);

  // these are client errors
  if (validationErrors) {
    errorDetails = getNestedErrors(validationErrors);
  } else {
    // these are server errors:
    const title = _.get(errorObj, 'error');
    const body = _.get(errorObj, 'errors');
    if (title && body) {
      // splitting it up for better message formatting
      errorDetails = getNestedErrors(title) + ': ' + getNestedErrors(body);
    } else if (title) {
      errorDetails = getNestedErrors(title);
    } else if (body) {
      errorDetails = getNestedErrors(body);
    } else {
      errorDetails =
        _.get(errorObj, 'response.statusText') ||
        _.get(errorObj, 'response.status') ||
        errorObj.message ||
        (typeof errorObj === 'string' && errorObj) ||
        '';
    }
  }
  return errorDetails;
};
